import {
	BasicFieldType,
	ContactTypeCode,
	Template,
	TemplateStatusCode,
} from '../types';

export const newTemplate = (notificationEmail: string): Template => ({
	name: {},
	instructions: {},
	formType: 'contact', // default values
	contactType: ContactTypeCode.member, // default values
	settings: {
		extraFields: {
			fields: {},
			displaySettings: [],
		},
		header: {},
		footer: {},
	},
	mainNotificationEmail: notificationEmail,
	extraNotificationEmails: [],
	status: TemplateStatusCode.draft,
});

export const BASIC_FIELD_TYPES: BasicFieldType[] = [
	BasicFieldType.TEXT,
	BasicFieldType.PASSWORD,
	BasicFieldType.INTEGER,
	BasicFieldType.NUMBER,
	BasicFieldType.URL,
	BasicFieldType.EMAIL,
	BasicFieldType.CHECKBOX,
	BasicFieldType.DATE,
	BasicFieldType.DATETIME,
	BasicFieldType.MC,
	BasicFieldType.MSEL,
	BasicFieldType.TAGS,
	BasicFieldType.MTEXT,
	BasicFieldType.FILE,
	BasicFieldType.GROUP,
	BasicFieldType.STATICTEXT,
	BasicFieldType.ARRAY,
];

export const BASIC_FIELDS = BASIC_FIELD_TYPES.map(basicField => {
	return basicField == BasicFieldType.GROUP
		? { type: basicField, elements: [] }
		: { type: basicField };
});

export const RULE_KEY_EQUAL = [
	{ value: 'eq', text: 'pages.form.editor.ruleKey.eq' },
	{ value: 'ne', text: 'pages.form.editor.ruleKey.ne' },
];

export const RULE_KEY_NUMBER = [
	{ value: 'lt', text: 'pages.form.editor.ruleKey.lt' },
	{ value: 'lte', text: 'pages.form.editor.ruleKey.lte' },
	{ value: 'gt', text: 'pages.form.editor.ruleKey.gt' },
	{ value: 'gte', text: 'pages.form.editor.ruleKey.gte' },
];

export const RULE_KEY_MSEL = [
	{ value: 'in', text: 'pages.form.editor.ruleKey.in' },
	{ value: 'nin', text: 'pages.form.editor.ruleKey.nin' },
];

export const MSEL_STYLE = [
	{ value: 'checkbox', text: 'pages.form.editor.style.checkbox' },
	{ value: 'ranking', text: 'pages.form.editor.style.ranking' },
	{ value: 'dropdown', text: 'pages.form.editor.style.dropdown' },
];

export const MC_STYLE = [
	{ value: 'radio', text: 'pages.form.editor.style.radio' },
	{ value: 'dropdown', text: 'pages.form.editor.style.dropdown' },
];
